/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Input,
  Spinner
} from "reactstrap";
import BorderedTable from "../../../shared/components/table/BorderedTable";
import ViewCompanyPage from "../../ViewCompanyPage/components/viewCompany";
// import Pagination from "../../../shared/components/pagination/Pagination";
import {
  getAllCompanies,
  getMoreCompanies,
  getThisCompany,
  getCompanyByEmail
} from "../../../redux/middlewares/Company/getCompany";
import { toast } from "react-toastify";
import firebase from "../../../config/firebase";
import ResourcePreview from "./ResourcePreview";
import ViewResource from "./viewResource";
import Select from "../../common/Select";
import AddNewResource from "./AddNewResource";

export default class ResourcesTable extends PureComponent {
  constructor() {
    super();
    this.heads = [
      {
        key: "SNo",
        name: "#",
        width: 80
      },
      {
        key: "id",
        name: "Id",
        width: 80
      },
      {
        key: "title",
        name: "Title",
        sortable: true
      },
      {
        key: "pageTitle",
        name: "Page Title",
        sortable: true
      },
      {
        key: "uploadedAt",
        name: "Uploaded At",
        sortable: true
      },
      {
        key: "status",
        name: "Status",
        sortable: true
      }
      //   {
      //     key: "action",
      //     name: "Action",
      //     sortable: true
      //   }
    ];

    this.status = [
      { label: "Published", value: "published" },
      { label: "Pending", value: "pending" },
      { label: "Draft", value: "saved" }
    ];

    // const initialPageNumber = 1;
    // const initialRowsCount = 10;

    // // const minRows = 20;
    // // const maxRows = 41;
    // // const rowsCount = Math.random() * (maxRows - minRows);
    // const originalRows = [];
    // const currentPageRows = this.filterRows(
    //   originalRows,
    //   initialPageNumber,
    //   initialRowsCount
    // );

    this.state = {
      rows: undefined,
      rowsPerPage: 20,
      page: 1,
      resources: undefined,
      loading: true,
      initialLimit: 25,
      moreData: false,
      lastVisible: undefined,
      clickedResource: undefined,
      whereClause: [],
      status: null,
      isOpen: false,
      searchQuery: "",
      searchKeyword: "",
      add: false
    };
    this.db = firebase.firestore().collection("resources");
  }

  callInitialData = () => {
    let that = this;
    this.db
      .limit(this.state.initialLimit)
      .orderBy("uploadedAt", "desc")
      .onSnapshot(
        function(snap) {
          that.setInitialData(snap);
        },
        function(error) {
          console.log(error);
          this.setState({ loading: false });
        }
      );
    //   .then(docs => {
    //     // console.log(docs);
    //     if (!docs.empty) {
    //       const { rowsPerPage, page } = { ...this.state };
    //       let resources = [];
    //       docs.forEach(job => resources.push({ ...job.data(), id: job.id }));
    //       let moreData = resources.length > this.state.rowsPerPage;
    //       // Checking for last data retrive
    //       let lastVisible = docs.docs[docs.docs.length - 1];
    //       console.log({ resources });
    //       this.setState({ resources, moreData, lastVisible }, () =>
    //         this.createRows(rowsPerPage, page)
    //       );
    //     } else {
    //       this.setState({ loading: false });
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     this.setState({ loading: false });
    //   });
  };

  // Set Data of Initial Query
  setInitialData = docs => {
    this.setState({ moreData: false, page: 1 });
    if (!docs.empty) {
      // console.log({ docs });
      const { rowsPerPage, page } = { ...this.state };
      let resources = [];
      docs.forEach(job => resources.push({ ...job.data(), id: job.id }));

      let moreData = resources.length > this.state.rowsPerPage;
      // Checking for last data retrive
      let lastVisible = docs.docs[docs.docs.length - 1];
      console.log({ moreData, lastVisible, resources });
      this.setState({ resources, moreData, lastVisible }, () =>
        this.createRows(rowsPerPage, page)
      );
    } else this.setState({ loading: false, resources: [], rows: undefined });
  };

  // Set Data After Loadmore query
  setMoreData = snap => {
    const { rowsPerPage, resources, page } = this.state;
    if (!snap.empty) {
      const newData = [];
      snap.forEach(docs => newData.push({ ...docs.data(), id: docs.id }));
      let allData = [...resources, ...newData];
      //  Check if the entry is already available
      const uniqueData = Array.from(new Set(allData.map(a => a.id))).map(id => {
        return allData.find(a => a.id === id);
      });
      // Checking for last data retrive
      let lastVisible = snap.docs[snap.docs.length - 1];
      let moreData = rowsPerPage * (page + 1) < uniqueData.length;
      this.setState({
        loading: false,
        resources: uniqueData,
        lastVisible,
        page: page + 1,
        moreData
      });
    } else {
      let moreData = resources.length > (page + 1) * rowsPerPage ? true : false;
      this.setState({ moreData, page: page + 1 });
    }
    this.createRows(rowsPerPage, page + 1);
  };

  componentDidMount() {
    this.callInitialData();
  }

  onChangePage = pageToGo => {
    const { page, rowsPerPage, resources } = this.state;
    // IF Data is Already avaliable direct render it.
    if (pageToGo < page || resources.length > pageToGo * rowsPerPage) {
      this.setState({ page: pageToGo, moreData: true }, () =>
        this.createRows(rowsPerPage, pageToGo)
      );
    }
    // Else call from Database.
    else if (pageToGo > page) {
      this.callMoreData();
    }
  };

  callMoreData = () => {
    const {
      rowsPerPage,
      resources,
      lastVisible,
      page,
      whereClause
    } = this.state;
    if (lastVisible) {
      this.setState({ loading: true });
      if (whereClause.length > 0) {
        // console.log("callMoreDt", statusFilter);
        this.FilteredQuery()
          // .where("status", "==", statusFilter.toLowerCase())
          .orderBy("uploadedAt", "desc")
          .limit(rowsPerPage)
          .startAfter(lastVisible)
          .get()
          .then(snap => {
            this.setMoreData(snap);
          })
          .catch(error => console.error(error.message));
      } else {
        this.db
          .limit(rowsPerPage)
          .orderBy("uploadedAt", "desc")
          .get()
          .startAfter(lastVisible)
          .then(snap => {
            this.setInitialData(snap);
          });
      }
    }
  };

  fromSecondsToDate = seconds => new Date(seconds * 1000).toLocaleDateString();

  // Make the arrangement Same As heads
  createRows = (rowsPerPage, page) => {
    const rows = [];
    // const that = this;
    const resources = [...this.state.resources];
    const start = rowsPerPage * (page - 1);
    const end =
      page === 1 && resources.length > rowsPerPage
        ? rowsPerPage
        : resources.length < start + rowsPerPage //rowsPerPage >= resources.length ||
        ? resources.length
        : rowsPerPage * page;

    // console.log({ resources, start, end });

    try {
      for (let i = start; i < end; i++) {
        // console.log(i);

        rows.push({
          sno: i + 1,
          id: resources[i].id, //resources[i].id,
          title: resources[i].title,
          pageTitle: resources[i].pageTitle,
          uploadedAt: resources[i].uploadedAt?.toDate().toLocaleDateString(),
          status: resources[i].status
        });
      }
    } catch (error) {
      console.error(error);
    }

    this.setState({ rows, loading: false });
  };

  filterRows = (originalRows, pageNumber, rowsOnPage) => {
    const rowsFrom = rowsOnPage * (pageNumber - 1);
    const rowsTo = rowsFrom + rowsOnPage;
    return originalRows.slice(rowsFrom, rowsTo);
  };

  toggleModal = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  onRowClickHandler = id => {
    const filter = this.state.resources.filter(e => e.id === id);
    if (filter.length > 0)
      this.setState({ clickedResource: filter[0] }, this.toggleModal());
  };

  onChangeSingleFilter = (field, value) => {
    console.log({ field, value });
    let where = [...this.state.whereClause];
    const prevIndex = where.findIndex(e => e[0] === field);
    console.log({ prevIndex, value });
    if (value === null || value === []) {
      if (prevIndex !== -1) {
        where.splice(prevIndex, 1);
        // console.log({ where });
        this.setState({ whereClause: where, [field]: null });
      }
    } else {
      if (prevIndex !== -1) where[prevIndex][2] = value.value;
      else where.push([field, "==", value.value]);
      this.setState({ whereClause: where, [field]: value }, () =>
        console.log("Where Clauese----", this.state.whereClause)
      );
    }
  };

  FilteredQuery = () => {
    let where = [...this.state.whereClause];
    let query = this.db;
    console.log({ where });
    try {
      if (where) {
        if (where[0] instanceof Array) {
          // It's an array of array
          for (let w of where) {
            console.log({ w });
            query = query.where(...w);
          }
        } else {
          query = query.where(...where);
        }
        console.log({ query, where });
        return query;
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Filters on Status
  onSubmitFilter = s => {
    this.setState({ moreData: false });
    const { initialLimit, whereClause } = this.state;
    // const status = s.toLowerCase();
    console.log({ whereClause });
    if (whereClause.length > 0) {
      this.setState({ loading: true });
      this.FilteredQuery()
        // .where("status", "==", status)
        .orderBy("uploadedAt", "desc")
        .limit(initialLimit)
        .get()
        .then(snap => {
          console.log({ snap });
          this.setInitialData(snap);
        })
        .catch(error => {
          console.error(error.message);
          toast.error(error.message);
          this.setState({
            loading: false,
            moreData: false,
            jobsArray: [],
            rows: undefined,
            lastVisible: undefined,
            page: 1
          });
        });
    } else this.InitialdataSelectionSetup();
  };

  // CLear state (Reinitialize)
  onClearState = () => {
    this.setState({
      rows: undefined,
      rowsPerPage: 10,
      page: 1,
      companies: undefined,
      loading: true,
      initialLimit: 15,
      moreData: false,
      lastVisible: undefined,
      clickedCompany: undefined,
      isOpen: false,
      searchQuery: "",
      searchKeyword: "",
      status: null
    });
  };

  //   Update Status
  updateResourceStatus = (id, status) => {
    // const clonedRows = [...this.state.rows];
    // const clonedResources = [...this.state.resources];
    // const index = clonedRows.findIndex(e => e.id === id);
    // const resourceIndex = clonedResource.findIndex(e => e.id === id);
    // // console.log("object----------", clonedRows, index);
    // if (index !== -1 && clonedRows[index].status !== status) {
    //   clonedRows[index].status = status;
    //   clonedRows[index].status = status;
    //   console.log({ clonedRows: clonedRows[index] });
    //   this.setState({ rows: clonedRows });
    // }
  };

  //   // Search Handler
  //   searchFilterHandler = () => {
  //     let query = this.state.searchKeyword;
  //     if (query && query.length > 0) {
  //       this.setState({ loading: true, searchQuery: query, companies: [] });
  //       getCompanyByEmail({ limit: this.state.initialLimit, email: query })
  //         .then(docs => {
  //           // console.log(docs);
  //           if (!docs.empty) {
  //             const { rowsPerPage, page } = { ...this.state };
  //             let companies = [];
  //             docs.forEach(com => companies.push({ ...com.data(), id: com.id }));
  //             let moreData = companies.length > this.state.rowsPerPage;
  //             // Checking for last data retrive
  //             let lastVisible = docs.docs[docs.docs.length - 1];
  //             this.setState({ companies, moreData, lastVisible }, () =>
  //               this.createRows(rowsPerPage, page)
  //             );
  //           } else {
  //             this.setState({ loading: false });
  //           }
  //         })
  //         .catch(error => {
  //           console.log(error);
  //           this.setState({ loading: false, searchQuery: "" });
  //           toast.error(error.message);
  //         });
  //     }
  //   };

  onClearFilters = () => {
    this.onClearState();
    this.callInitialData();
  };

  render() {
    const {
      rows,
      moreData,
      page,
      loading,
      searchKeyword,
      searchQuery,
      status,
      add
    } = this.state;
    // console.log(rows);

    return (
      <Col md={12} lg={12}>
        <Button onClick={() => this.setState({ add: !add })} color="primary">
          {add ? "Back" : "+ Add New Resource"}
        </Button>
        {add ? (
          <AddNewResource
            onSubmitResource={() => this.setState({ add: !add })}
          />
        ) : (
          <Card>
            {this.state.clickedResource && (
              <Modal
                isOpen={this.state.isOpen}
                toggle={this.toggleModal}
                className="edit-job-modal"
              >
                <ModalHeader toggle={this.toggleModal}>Resources</ModalHeader>
                <ModalBody>
                  <ViewResource
                    resource={this.state.clickedResource}
                    updateStatusInParent={this.updateResourceStatus}
                    onResourceDeleteSuccess={this.toggleModal}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={this.toggleModal}
                    size="sm"
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            )}
            <CardBody>
              <Row>
                <Col md={3}>
                  <Select
                    placeholder="Status"
                    value={status}
                    options={this.status}
                    disabled={loading}
                    onChange={val => this.onChangeSingleFilter("status", val)}
                  />
                </Col>
                <Col
                  md={2}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "flex-end"
                  }}
                >
                  <Button
                    outline
                    color="primary"
                    size="sm"
                    onClick={this.onSubmitFilter}
                    style={{ marginBottom: "0px" }}
                    disabled={loading}
                  >
                    Submit
                  </Button>{" "}
                </Col>
                <Col
                  md={2}
                  style={{
                    textAlign: "left",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "flex-end"
                  }}
                >
                  <Button
                    outline
                    color="danger"
                    size="sm"
                    onClick={this.onClearFilters}
                    style={{ marginBottom: "0px" }}
                    disabled={loading}
                  >
                    Clear
                  </Button>{" "}
                </Col>
              </Row>
              {/* <Row>
              <Col md={4}></Col>
              <Col sm={12} md={4}>
                <form onSubmit={this.searchFilterHandler}></form>
                <Row>
                  <Col md={9} style={{ paddingRight: "0px" }}>
                    <Input
                      type="search"
                      placeholder="Company email"
                      value={searchKeyword}
                      onChange={e =>
                        this.setState({ searchKeyword: e.target.value })
                      }
                      style={{ borderRadius: "0px" }}
                    />
                  </Col>
                  <Col md={3} style={{ paddingLeft: "0px" }}>
                    <Button
                      color="primary"
                      style={{ height: "2.4rem", borderRadius: "0px" }}
                      onClick={this.searchFilterHandler}
                    >
                      Search
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col md={4}></Col>
            </Row> */}
              {/* {searchQuery && (
              <Row>
                <Col sm={1} style={{ display: "flex", alignItems: "center" }}>
                  <div className="card__title" style={{ marginBottom: "0px" }}>
                    <h5 className="bold-text">Search:</h5>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="filters-list">
                    <li>
                      <span style={{ minWidth: "100%" }}>
                        {this.state.searchQuery}
                      </span>

                      <img
                        src={require("../../../assets/images/close.png")}
                        alt="close"
                        onClick={() => this.onClearFilters()}
                      />
                    </li>
                  </div>
                </Col>
              </Row>
            )} */}

              {/* Previous */}
              <div
                style={{
                  height: "400px",
                  overflow: "auto",
                  border: "1px solid #efefef  ",
                  // display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                {loading ? (
                  <h3
                    style={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Spinner type="grow" color="info" />
                  </h3>
                ) : rows ? (
                  <BorderedTable
                    heads={this.heads}
                    rows={rows}
                    onRowClickHandler={this.onRowClickHandler}
                  />
                ) : (
                  <h3
                    style={{
                      height: "400px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    No Resource Found!
                  </h3>
                )}
              </div>

              <Row style={{ margin: "1vw .2vw" }}>
                <Col sm={6}>
                  <Button
                    color="primary"
                    size="sm"
                    disabled={page === 1}
                    onClick={() => this.onChangePage(page - 1)}
                  >
                    Prev
                  </Button>
                </Col>
                <Col sm={6} style={{ textAlign: "end" }}>
                  <Button
                    color="primary"
                    size="sm"
                    disabled={!moreData}
                    onClick={() => this.onChangePage(page + 1)}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
              {/* <Pagination
              itemsCount={rows.length}
              itemsToShow={itemsToShow}
              pageOfItems={pageOfItems}
              onChangePage={this.onChangePage}
            /> */}
            </CardBody>
          </Card>
        )}
      </Col>
    );
  }
}
